import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SmoothScroll } from "@/components/layout/SmoothScroll";
import { ScrollToTop } from "@/components/layout/ScrollToTop";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import UpcomingMarket from "@/pages/UpcomingMarket";
import BookAStall from "@/pages/BookAStall";
import Gallery from "@/pages/Gallery";
import Sponsor from "@/pages/Sponsor";
import Contact from "@/pages/Contact";
import Policies from "@/pages/Policies";
import VendorBooking from "@/pages/vendor/VendorBooking";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import EntryForm from "@/pages/EntryForm";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <SmoothScroll>
          <Routes>
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/about" element={<Layout><About /></Layout>} />
            <Route path="/upcoming-market" element={<Layout><UpcomingMarket /></Layout>} />
            <Route path="/book-a-stall" element={<Layout><BookAStall /></Layout>} />
            <Route path="/gallery" element={<Layout><Gallery /></Layout>} />
            <Route path="/sponsor" element={<Layout><Sponsor /></Layout>} />
            <Route path="/contact" element={<Layout><Contact /></Layout>} />
            <Route path="/policies" element={<Layout><Policies /></Layout>} />
            <Route path="/vendor-booking" element={<Layout><VendorBooking /></Layout>} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/entry" element={<EntryForm />} />
          </Routes>
        </SmoothScroll>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
